// action - state management
import {
    GET_ALL_PROJECT,
    GET_PROJECT_DETAIL,
    REMOVE_PROJECT_DETAIL,
    SET_LOADING,
    SET_PAGE,
    GET_ALL_DROPDOWN,
    GET_CLIENT_DROPDOWN,
    GET_BUDGET_DETAILS,
    UPDATE_PROJECT_STATUS_OPTIMISTIC,
    ROLLBACK_PROJECT_STATUS,
    ROLLBACK_PAYMENT_DELETION,
    OPTIMISTIC_UPDATE_PAYMENT_DELETION
} from "./actions";

// ==============================|| ACCOUNT REDUCER ||============================== //

const initialState = {
    project_List: {},
    budget_details: {},
    project_Details: {},
    all_clients: {},
    account_dropdown: {},
    bde_dropdown: {},
    currency_dropdown: {},
    loading: true,
    detail_loading: true,
    page: 1,
};

// const projectReducer = (state = initialState, action) => {
export const projectReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case GET_ALL_PROJECT:
            return {
                ...state,
                project_List: payload,
                loading: false,
            };
        case GET_ALL_DROPDOWN:
            return {
                ...state,
                account_dropdown: payload.account,
                bde_dropdown: payload.bde,
                currency_dropdown: payload.currency,
            };
        case GET_CLIENT_DROPDOWN:
            return {
                ...state,
                all_clients: payload,
            };
        case GET_PROJECT_DETAIL:
            return {
                ...state,
                project_Details: payload,
                detail_loading: false,
            };
        case REMOVE_PROJECT_DETAIL:
            return {
                ...state,
                project_Details: {},
                detail_loading: true,
            };
        case SET_PAGE:
            return {
                ...state,
                page: payload,
            };
        case SET_LOADING:
            return {
                ...state,
                loading: true
            }
        case GET_BUDGET_DETAILS:
            return {
                ...state,
                budget_details: payload
            }

        case UPDATE_PROJECT_STATUS_OPTIMISTIC: {
            const { id, newStatus } = action.payload;

            return {
                ...state,
                project_List: {
                    ...state.project_List,
                    docs: state.project_List.docs.map(project => {
                        if (project._id !== id) return project;

                        const updatedProject = { ...project, status: newStatus };

                        if (newStatus === 2) {
                            // Extract currency from either released or balance budget
                            const currencyMatch = project.released_budget.match(/\d+\.?\d*([A-Za-z]+)/) ||
                                project.balance_budget.match(/\d+\.?\d*([A-Za-z]+)/);
                            const currency = currencyMatch?.[1] || 'USD';

                            const released = parseFloat(project.released_budget) || 0;
                            const balance = parseFloat(project.balance_budget) || 0;

                            updatedProject.released_budget = `${(released + balance).toFixed(0)}${currency}`;
                            updatedProject.balance_budget = `0${currency}`;
                        }

                        return updatedProject;
                    })
                }
            };
        }
        case OPTIMISTIC_UPDATE_PAYMENT_DELETION: {
            const { projectId, deletedAmount, previousProject } = action.payload;

            return {
                ...state,
                project_List: {
                    ...state.project_List,
                    docs: state.project_List.docs.map(project => {
                        if (project._id !== projectId) return project;

                        // Extract numeric value and currency from released_budget
                        const releasedMatch = project.released_budget.match(/(\d+\.?\d*)([A-Za-z]+)/);
                        const releasedValue = releasedMatch ? parseFloat(releasedMatch[1]) : 0;
                        const releasedCurrency = releasedMatch?.[2] || 'USD';

                        // Extract numeric value and currency from balance_budget
                        const balanceMatch = project.balance_budget.match(/(\d+\.?\d*)([A-Za-z]+)/);
                        const balanceValue = balanceMatch ? parseFloat(balanceMatch[1]) : 0;
                        const balanceCurrency = balanceMatch?.[2] || 'USD';

                        // Ensure currencies match (use released_budget's currency as primary)
                        const currency = releasedCurrency || balanceCurrency || 'USD';

                        return {
                            ...project,
                            released_budget: `${(releasedValue - deletedAmount).toFixed(0)}${currency}`,
                            balance_budget: `${(balanceValue + deletedAmount).toFixed(0)}${currency}`,
                            _previousState: {
                                released_budget: project.released_budget,
                                balance_budget: project.balance_budget
                            }
                        };
                    })
                },
                _previousProjects: {
                    ...state._previousProjects,
                    [projectId]: previousProject
                }
            };
        }
        case ROLLBACK_PROJECT_STATUS:
            return {
                ...state,
                project_List: {
                    ...state.project_List,
                    docs: action.payload
                }
            };

        case ROLLBACK_PAYMENT_DELETION: {
            const { projectId, previousProject } = action.payload;

            return {
                ...state,
                project_List: {
                    ...state.project_List,
                    docs: state.project_List.docs.map(project => {
                        if (project._id !== projectId) return project;

                        // Use either the explicitly passed previousProject
                        // Or the _previousState stored in the project
                        return previousProject || {
                            ...project,
                            released_budget: project._previousState?.released_budget || project.released_budget,
                            balance_budget: project._previousState?.balance_budget || project.balance_budget
                        };
                    })
                },
                // Clear the stored previous state
                _previousProjects: Object.keys(state._previousProjects || {})
                    .filter(id => id !== projectId)
                    .reduce((obj, key) => {
                        obj[key] = state._previousProjects[key];
                        return obj;
                    }, {})
            };
        }



        default:
            return state;
    }
}

export default projectReducer;